import React from 'react';
import { Text, StyleSheet } from '@react-pdf/renderer';
import { pdfColors, pdfFontSize, pdfRadius, pdfSpacing } from '../theme';

const styles = StyleSheet.create({
  strip: {
    marginBottom: pdfSpacing.md,
    paddingVertical: 5,
    paddingHorizontal: 10,
    backgroundColor: pdfColors.surfaceSoft,
    borderWidth: 0.6,
    borderColor: pdfColors.divider,
    borderStyle: 'solid',
    borderRadius: pdfRadius.md,
    fontSize: pdfFontSize.xs,
    color: pdfColors.textSecondary,
  },
  key: { fontWeight: 600, color: pdfColors.textPrimary },
});

/** "Filters: Status: APPROVED • From: 01 Oct 2026" — so a printed report explains its own scope. */
const FilterStrip: React.FC<{ summary: string }> = ({ summary }) => (
  <Text style={styles.strip} wrap={false}><Text style={styles.key}>Filters: </Text>{summary}</Text>
);

export default FilterStrip;
